<template>
    <div id="works">
        <div id="top"> </div>
        <div class="student-info info-el">
            <li>{{currentWork.name}}</li>
            <li>{{currentWork.tel}}</li>
            <li>{{currentWork.email}}</li>
            <li><a :href="currentWork.website">{{currentWork.website}}</a></li>
            <li>
                <ul class="workInfo info-el" v-for="(item, i) in currentWork.works" :key="i">
                    <!-- <li class="workInfo-title" >
                        <span class="circle" v-for="(item2 ,j) in currentWork.works" :key="j"></span>
                        {{currentWork.works[i].name}}
                    </li> -->
                    <li class="workInfo-title" :class="'title'+i" @click="showTxt(i)"> 0{{i+1}} {{currentWork.works[i].name}} <img src="../assets/arr-down.svg" alt="내용 보기"> </li>
                    <li class="workInfo-text" :class="'txt'+i"> {{currentWork.works[i].txt}} </li>
                    <li class="works-mobile"> <img :src="currentWork.works[i].source" alt="" class="works-img"> </li>
                </ul>
            </li>
        </div>
        <carousel
        :perPage="1"
        paginationActiveColor="#ed86a1"
        paginationColor="#999"
        :paginationPadding="4"
        :navigationEnabled="true"
        :navigationNextLabel="navigationNext"
        :navigationPrevLabel="navigationPrev"
        :navigationClickTargetSize="12"
        class="info-el"
        :loop="true"
        >
            <slide class="student-works"
            v-for="(item, i) in currentWork.works" :key="i"
            :style="{backgroundImage: `url(${item.source})`}"
            >
                <!-- <img src="../assets/placeholder.jpg" alt=""> -->
            </slide>
        </carousel>
        <div class="btns">
            <button @click="goBackWork" v-show="index > 0"> &lt; {{ backWork.name }}</button>
            <button @click="goFrontWork" v-if="index < $store.state.students.length -1"> {{ frontWork.name }} &gt;</button>
            <button class="btn-goTop"><a href="#top">&uarr; 맨 위로</a></button>
        </div>
    </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
import ChevronRight from '../assets/arrow_right.png';
import ChevronLeft from '../assets/arrow_left.png';

export default {
    components: {
        Carousel,
        Slide
    },
    data() {
        return {
            index: Number(this.$route.path.split('/')[2]),
            workImgs: this.$store.state.workImgs,
        }
    },
    computed: {
        navigationPrev() {
            const chevronLeft = ChevronLeft
            return `<img class="slide-btn btn-slide-prev" src="${ChevronLeft}"/>`
        },
        navigationNext() {
            const chevronRight = ChevronRight
            return `<img class="slide-btn btn-slide-next" src="${ChevronRight}"/>`
        },
        backWork() {
            return this.$store.getters.allStudents.find(r => r.number == this.index - 1) || false
        },
        currentWork(){
            return this.$store.getters.allStudents.find(r => r.number == this.index) || false
        },
        frontWork(){
            return this.$store.getters.allStudents.find(r => r.number == this.index + 1) || false
        }
    },
    methods: {
        goBackWork(){
            this.$router.push('/archive/'+ this.backWork.number)
            this.$router.go(0)
        },
        goFrontWork() {
            this.$router.push('/archive/'+ this.frontWork.number)
            this.$router.go(0)
        },
        showTxt(i){
            document.querySelector('.txt'+i).classList.toggle('txt-active')
            document.querySelector('.title'+i).classList.toggle('title-clicked')

            const removeTitle = document.querySelectorAll('.workInfo-title:not(.title'+i)
            const removeList = document.querySelectorAll('.workInfo-text:not(.txt'+i)
            for(let j=0; j < removeList.length; j++){
                removeTitle[j].classList.remove('title-clicked')
                removeList[j].classList.remove('txt-active')
            }
        }
    },

    mounted() {
        setInterval(this.$store.commit('showDetail'), 4000)
        
    }
}
</script>

<style scoped>
@media all and (max-width: 767px) {
    #top {
        position: absolute;
        top: 0;
        left: 0;
    }
    #works {
        width: 92vw;
        margin: 88px auto;
        padding: 88px auto;
    }

    /* 학생정보 */
    .student-info {
        width: 92vw;
    }
    .student-info li {
        list-style: none;
        margin: 16px 0 0 0;
        font-size: 1rem;
    }
    .info-el {
        opacity: 0;
    }
    /* 학생정보 (이름) */
    .student-info > li:first-child {
        font-size: 1.2rem;
        font-weight: 900;
    }
    /* 학생정보 (사이트 주소) */
    .student-info li a:link, .student-info li a:active, .student-info li a:visited {
        border-bottom: 2px solid #ed86a1;
    } 


    /* 작품정보 */
    .workInfo {
        margin: 40px 0 0;
    }
    /* 작품제목 */
    .workInfo .workInfo-title {
        font-size: 1rem;
        line-height: 1.6rem;
        font-weight: 900;
    }
    .workInfo .workInfo-title img{
        display: none;
    }

    /* 작품설명 */
    .workInfo-text{
        font-size: 0.8rem;
        line-height: 1.4rem;
        margin: 0 0 16px 0;
        word-break: keep-all;
        font-weight: 400;
    }

    /* 작품 이미지들 */
    .works-mobile {
        width: 92vw;
        height: auto;
        margin: 0 auto;
    }
    .works-mobile img {
        width: 92vw;
        height: auto;
        margin: 0 auto;
        text-align: center;
    }
    .VueCarousel {
        display: none;
    }
    .student-works {
        display: none;
    }

    /* 이전, 다음 작품으로가는 버튼 */
    .btns {
        width: 92vw;
        margin: 48px auto;
    }
    .btns button{
        appearance: none;
        background: none;
        color: #ed86a1;
        border: 0;
        font-size: 0.9rem;
    }
}

@media all and (min-width: 768px) {
    .btn-goTop {
        display: none;
    }
    #works {
        width: 96vw;
    }

    /* 학생정보 */
    .student-info {
        width: 21vw;
        position: fixed;
        top: 72px;
        left: 2vw;
        padding: 0 0 4px;
    }
    .student-info > li {
        list-style: none;
        margin: 16px 0;
        font-size: 1.2rem;
    }
    .info-el {
        opacity: 0;
    }
    /* 학생정보 (이름) */
    .student-info > li:first-child {
        font-size: 2rem;
        margin: 32px 0 40px;
        font-weight: 900;
    }
    /* 학생정보 (사이트 주소) */
    .student-info li a:link, .student-info li a:active, .student-info li a:visited {
        border-bottom: 2px solid #ed86a1;
    } 

    /* 작품정보 */
    .workInfo {
        margin: 24px 0 0;
    }
    .workInfo:first-child {
        margin: 56px 0 0;
    }
    /* 작품제목 */
    .workInfo .workInfo-title {
        font-size: 1.2rem;
        font-weight: 900;
        cursor: pointer;
        display: inline;
    }
    .workInfo .workInfo-title img{
        width: 16px;
    }
    .workInfo .title-clicked img{
        transform: rotate(180deg);
        transition: 0.3s;
    }
    /* .workInfo .workInfo-title .circle {
        display: inline-block;
        width: 9px;
        height: 9px;
        background: #999;
        border-radius: 50%;
        margin: 3px;
    } */

    /* 작품설명 */
    .workInfo-text {
        margin: 8px 0 24px;
        font-size: 1rem;
        line-height: 1.6em;
        word-break: keep-all;
        font-weight: 400;
        display: none;
    }
    .txt-active {
        display: block;
    }

    .works-mobile {
        display: none;
    }

    /* 작품 이미지들 */
    .VueCarousel {
        width: 68vw;
        height: 82vh;
        min-width: 1000px;
        margin: 8vh 0 0 0;
        position: absolute;
        right: 4vw;
        z-index: -1;
    }
    .student-works {
        width: 100%;
        height: 100%;
        min-width: 1000px;
        background-size: contain;
        background-position-x: center;
        background-position-y: center;
        background-repeat: no-repeat;
    }
    /* placeholder */
    .student-works {
        width: 1310px;
        height: 858px;
        min-width: 1000px;
        vertical-align: top;
        text-align: start;
    }
    
    /* 이전, 다음 작품으로가는 버튼 */
    .btns {
        height: 32px;
        position: absolute;
        left: 28vw;
        bottom: 0;
        z-index: 9999;
    }
    .btns button{
        appearance: none;
        background: none;
        color: #ed86a1;
        border: 0;
        font-size: 0.9rem;
    }
}

</style>


// WEBPACK FOOTER //
// src/components/WorksDetail.vue